/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Settings/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ArchiveAction from './ArchiveAction/index'
import ArchiveModal from './ArchiveModal/index'
import BoardName from './BoardName/index'
import CancelAction from './CancelAction/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import IconPicker from './IconPicker/index'
import Locations from './Locations/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import Stages from './Stages/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Settings({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Settings"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Settings.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-1LhhG7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-2-1LhhG7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-1LhhG7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginBottom={dtSpaceXxxs}
 level="h4"
 text="Board Settings"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral500}
 text="Set board name, and add stages for tasks to go through from start to completion."
 marginBottom={dtSpaceLs}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginBottom={dtSpaceS}
/>
<IconPicker
  viewPath={`${viewPath}/IconPicker`}
/>
<BoardName
  viewPath={`${viewPath}/BoardName`}
/>
<Stages
  viewPath={`${viewPath}/Stages`}
/>
<Locations
  viewPath={`${viewPath}/Locations`}
/>
<ArchiveAction
  viewPath={`${viewPath}/ArchiveAction`}
/>
<div
  data-testid="Settings.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
/>
</div>
<div
  data-testid="Settings.Vertical:2"
  data-view-path={viewPath}
 style={{'--b-4-1LhhG7': dtColorsWhite}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Settings.Vertical:3"
  data-view-path={viewPath}
 style={{'--mb-5-1LhhG7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="Settings.Vertical:4"
  data-view-path={viewPath}
 style={{'--bc-6-1LhhG7': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical4}`}
/>
<div
  data-testid="Settings.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-7-1LhhG7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
</div>
</div>
</div>
<ArchiveModal
  viewPath={`${viewPath}/ArchiveModal`}
/>
{children}
</React.Fragment>)
}